// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApprovalTypeSchemeService = {};

ApprovalTypeSchemeService.getApprovalTypeSchemeService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApprovalTypeScheme/ApprovalTypeScheme?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&approvalSchemeId=" +
      data?.approvalSchemeId +
      "&approvalTypeId=" +
      data?.approvalTypeId +
      "&description=" +
      data?.description ,
    method: "get",
  });
};

ApprovalTypeSchemeService.postApprovalTypeSchemeService = function (data) {
 
  return lossClient({
    url: `/ApprovalTypeScheme/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApprovalTypeSchemeService.putApprovalTypeSchemeService = function (data) {
 
  return lossClient({
    url: `/ApprovalTypeScheme/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.requestId,
    },
    data: data?.data,
  });
};

export default ApprovalTypeSchemeService;
